// extracted by css-extract-rspack-plugin
export default {"cls1":"step_two-cls1_zuf","cls2":"step_two-cls2_UBF step_two-cls1_zuf"};